module.exports = "/_next/static/images/8f5c177bec628e6b46f28a0d87a65ba3-xpeer-fgts@0.75x.jpg.webp";